export const isExperimentsEnabled = process.env.REACT_APP_EXPERIMENTS === "true";

export const isSetWorkflowStatusEnabled = process.env.REACT_APP_IS_SET_WORKFLOW_STATUS_ENABLED === "true";

export const isLiveAppointmentsEnabled = process.env.REACT_APP_LIVE_APPOINTMENTS === "true";

export const isReferralInboxEnabled = process.env.REACT_APP_REFERRAL_INBOX === "true";

export const isAIReferralInboxEnabled = process.env.REACT_APP_AI_REFERRAL_INBOX === "true";

export const isAIResultInboxEnabled = process.env.REACT_APP_AI_RESULT_INBOX === "true";

export const isGPReportUploadEnabled = process.env.REACT_APP_GP_REPORT_UPLOAD === "true";

export const isGPReportListEnabled = process.env.REACT_APP_GP_REPORT_LIST === "true";

export const isPmsBookingEnabled = process.env.REACT_APP_FEATURE_PMS_BOOKING_ENABLED === "true";

export const isManualArchiveWorkflowEnabled = process.env.REACT_APP_MANUAL_ARCHIVE_WORKFLOW === "true";
